import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase } from '@digibricks/core';
import { HeadingStatus } from '../../../domain';
export var SAVE_HEADING_USE_CASE = 'SAVE_HEADING_USE_CASE';
export var SaveHeadingUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(SaveHeadingUseCase, _UseCase);

  var _super = _createSuper(SaveHeadingUseCase);

  function SaveHeadingUseCase(formRepository) {
    var _this;

    _classCallCheck(this, SaveHeadingUseCase);

    _this = _super.call(this);
    _this.formRepository = formRepository;
    return _this;
  }

  _createClass(SaveHeadingUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var heading, _input$isSkipApiCall, isSkipApiCall, updateHeadingInput;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                heading = input.heading, _input$isSkipApiCall = input.isSkipApiCall, isSkipApiCall = _input$isSkipApiCall === void 0 ? false : _input$isSkipApiCall;

                if (!isSkipApiCall) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.ok(heading));

              case 3:
                if (!(heading.status === HeadingStatus.New)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", this.formRepository.createHeading(heading));

              case 7:
                updateHeadingInput = {
                  data: {
                    formId: input.formId,
                    headingId: input.heading.id.toString(),
                    title: input.heading.title,
                    description: input.heading.description
                  }
                };
                return _context.abrupt("return", this.formRepository.updateHeading(updateHeadingInput));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return SaveHeadingUseCase;
}(UseCase);